import __base_store from '@/store/__base_store'

/**
 * Store de funcionalidades de plan (modelo `plan_feature`) construido desde el factory común.
 */
export default __base_store({
	state: {
		model_name: 'plan_feature',
	},
})

